'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _componentsDatagrid = require('../../components/Datagrid');

var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);

var _helpersRenderers = require('../../helpers/Renderers');

var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var _constants2 = _interopRequireDefault(_constants);

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactisDatagrid = require('reactis-datagrid');

var _reactBootstrap = require('react-bootstrap');

var _reactisModal = require('reactis-modal');

var _componentsFormDateRange = require('../../components/Form/DateRange');

var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _componentsFormActiveSelect = require('../../components/Form/ActiveSelect');

var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);

var _componentsFormClientLookup = require('../../components/Form/ClientLookup');

var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);

var _RowItems = require('./RowItems');

var _RowItems2 = _interopRequireDefault(_RowItems);

var _components = {
	_$List: {
		displayName: 'List'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var List = (function (_Component) {
	_inherits(List, _Component);

	function List(props, context) {
		var _this = this;

		_classCallCheck(this, _List);

		_Component.call(this, props);

		var rendererLink = function rendererLink(val, row) {
			return _react2['default'].createElement(
				'a',
				{ href: '/invoice/' + row.id, onClick: function (e) {
						return _this.handleOpen(row, e);
					} },
				val
			);
		};

		this.columnModel = [{
			name: 'number',
			title: 'Číslo',
			field: 'number',
			align: 'center',
			width: 70,
			renderer: rendererLink
		}, {
			name: 'date1',
			title: 'Datum',
			field: 'date1',
			align: 'right',
			viewport: 'tablet',
			renderer: _helpersRenderers2['default'].Date
		}, {
			name: 'price',
			title: 'Cena',
			field: 'price',
			align: 'right',
			width: 100,
			suffix: ' Kč',
			renderer: _helpersRenderers2['default'].Number,
			viewport: 'tablet'
		}, {
			name: 'status',
			title: 'Zapl.',
			field: 'status',
			width: 50,
			align: 'center',
			viewport: 'tablet',
			renderer: _helpersRenderers2['default'].coloredCheck
		}, {
			name: 'edit',
			title: 'Akce',
			field: 'id',
			width: 80,
			sortable: false,
			renderer: function renderer(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/invoice/' + val, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					_react2['default'].createElement('i', { className: 'fa fa-pencil' })
				);
			}
		}];
		this.defaultSort = { column: 'date1', 'direction': 'desc' };
	}

	List.prototype.handleOpen = function handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('invoice', '#' + row.number, row);
	};

	List.prototype.render = function render() {
		return _react2['default'].createElement(_componentsDatagrid2['default'], {
			id: this.props.id,
			api: 'invoice.getList',
			expandableComponent: _RowItems2['default'],
			limit: 10,
			disableButtons: true,
			getRowClassName: null,
			fixedFilter: { client: this.props.client },
			columnModel: this.columnModel,
			defaultFilter: this.defaultFilter,
			defaultSort: this.defaultSort
		});
	};

	var _List = List;
	List = _wrapComponent('_$List')(List) || List;
	return List;
})(_componentsComponent2['default']);

exports['default'] = List;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Invoice/MiniList.js
 ** module id = 987
 ** module chunks = 2
 **/